import { FormattedMessage } from 'react-intl'
import Container, { ShiftAlign } from './layout/Container'
import Stack from './layout/Stack'
import SectionIntro, { SectionIntroHTML } from './SectionIntro'
import Button from './Button'
import Link from './Link'
import Activities from './activities/Activities'

function LetsMake( { title, description, activities } ) {
  return (
    <Container>
      <ShiftAlign>
        <SectionIntro>
          <h2>{ title }</h2>
          <div>
            <SectionIntroHTML dangerouslySetInnerHTML={ { __html: description } } />
            <Button
              $inline
              $outline
            >
              <Link href="/lets-make">
                <FormattedMessage
                  description="Button: View all creative responses"
                  defaultMessage="View all creative activities"
                  id="Y3NRa/"
                />
              </Link>
            </Button>
          </div>
        </SectionIntro>
      </ShiftAlign>
      <Stack
        $top={ 2 }
        $bottom={ 2 }
      >
        <Activities activities={ activities.slice( 0, 3 ) } />
      </Stack>
    </Container>
  )
}

export default LetsMake
